module.exports = __webpack_public_path__ + "a06c9f85cb619a2ff5e4e0039835614b.jpg";